<template>
  <div class="box">
    <admin-box-item title="가격정보" desc="예약을 몇시간 전까지 받을 지 설정합니다.">
      <admin-form-item label="판매가격 사용여부">
        <lp-radio :val.sync="prod_price.price_type"
                  value_name="value"
                  label_name="label"
                  :data="[{label:'사용',value:0}, {label:'대체문구 사용', value:1}]"></lp-radio>
      </admin-form-item>
      <admin-form-item label="판매가격 대체문구" v-if="prod_price.price_type === 1" style="margin-top:16px">
              <span class="select">
                <select v-model="selected_alt_text.value" @change="selectAltText">
                  <option :value="text.value" v-for="(text, text_idx) in alt_text_arr" :key="`alt_text-${text_idx}`">
                    {{ text.label }}</option>
                </select>
              </span>
        <input class="input"
               style="margin-top:8px"
               :value="prod_price.price_text"
               @input="e => prod_price.price_text = e.target.value"
               type="text" v-if="selected_alt_text.value===6">
      </admin-form-item>
      <admin-form-item label="기본 가격설정" style="margin-top:16px" v-if="prod_price.price_type === 0">
        <button v-if="reservePrice.length === 0" @click="clickAdd"
                class="button is-primary button-price">가격 설정하기</button>
        <template v-else>
          <table class="price-table">
            <tr>
              <th style="width:10%">적용기간</th>
              <th style="width:80%">가격</th>
              <th style="width:10%">수정</th>
            </tr>
            <tr v-for="(item,idx) in reservePrice" :key="`tr-${idx}`">
              <td class="size-13">{{ datesFormat(item.start_date, 'date_9') }} ~ {{ datesFormat(item.end_date, 'date_9') }}</td>
              <td>
                <div class="flex size-13" style="gap: 10px">
                  <template v-if="item.is_discount">
                    <div class="sub1">정가 : {{ currency(item.price) }}</div>
                    <div class="primary">
                      <template v-if="item.discount_type===0">할인율 : {{ item.discount_rate }}%</template>
                      <template v-else>할인금액 : {{ currency(item.discount_price) }}</template>
                    </div>
                  </template>
                  <div class="main">판매가 : {{ currency(item.sale_price) }}</div>
                </div>
              </td>
              <td>
                <div class="flex-center btn-group">
                  <button class="button" @click="clickUpdate(item,idx)">수정</button>
                  <button class="button button-delete" @click="clickDelete(idx)">삭제</button>
                </div>
              </td>
            </tr>
          </table>
          <div class="flex">
            <div class="flex-align unselect" style="gap:6px" @click="clickAdd">
              <div class="btn-add"><i class="material-icons">add</i></div>
              <div class="size-13 primary">가격 설정 추가하기</div>
            </div>
          </div>
        </template>
      </admin-form-item>
    </admin-box-item>
    <modal-reserve-price ref="priceModal"
                         @add="onAdd"
                         @update="onUpdate"
                         :price="selectedPrice"></modal-reserve-price>
  </div>
</template>

<script>
  import ModalReservePrice from "./ModalReservePrice";
  import LpRadio from "../../../module/common/LpRadio";
  export default {
    name: "PanelReservePrice",
    components: {LpRadio, ModalReservePrice},
    props: {
      prod_price: {
        type: Object
      },
      reservePrice: {
        type: Array
      }
    },
    data() {
      return {
        alt_text_arr: [
          { label: '관리자에게 문의', value: 1 },
          { label: '파트너에게 문의', value: 2 },
          { label: '회원 전용가', value: 3 },
          { label: '이벤트가', value: 4 },
          { label: '가격문의', value: 5 },
          { label: '직접입력', value: 6 }
        ],
        // 대체텍스트 문구
        selected_alt_text: {
          label: '',
          value: 0
        },
        selectedIndex: -1,
        selectedPrice: undefined
      }
    },
    methods: {
      selectAltText(e) {
        let val = parseInt(e.target.value);
        // 직접 입력일 경우 예외처리
        if(val===6) {
          this.prod_price.price_text = '';
        }
        else {
          this.prod_price.price_text = find(this.alt_text_arr, 'value', val).label;
        }
      },
      clickAdd() {
        this.selectedPrice = undefined;
        this.$refs.priceModal.open();
      },
      clickUpdate(item, index) {
        this.selectedIndex = index;
        this.selectedPrice = item;

        this.$refs.priceModal.open();
      },
      onAdd(item) {
        item.id = 1;
        this.reservePrice.splice(0,0,item);
      },
      onUpdate(item) {
        this.reservePrice[this.selectedIndex] = item;
        this.$forceUpdate();
      },
      clickDelete(idx) {
        removeIndex(this.reservePrice, idx);
        this.$forceUpdate();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .text-deadline
    font-size 13px
    color #787878

  .button-price
    width 127px

  .sub1
    color #787878
  .main
    color #363636

  .button-delete
    background-color #ff0000
    color white

  .price-table
    th
      background-color #f5f5f5
      text-align center !important
    th, td
      font-size 13px
      text-align center
      vertical-align middle

  .btn-group
    gap 4px
    button
      width 44px
  .btn-add
    background-color #fff0eb
    border-radius 100%
    width 26px
    height 26px
    display flex
    justify-content center
    align-items center

    i
      color #ff5722
      font-size 20px
</style>
